var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWhiteSaveIcon = function SvgWhiteSaveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5H20l5 5v12.5a2.5 2.5 0 0 1-2.5 2.5h-15A2.5 2.5 0 0 1 5 22.5v-15A2.5 2.5 0 0 1 7.5 5",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5v5H10V5M22.5 24.545v-6.818h-15v6.818",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgWhiteSaveIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNSA1SDIwTDI1IDEwVjIyLjVDMjUgMjMuMTYzIDI0LjczNjYgMjMuNzk4OSAyNC4yNjc4IDI0LjI2NzhDMjMuNzk4OSAyNC43MzY2IDIzLjE2MyAyNSAyMi41IDI1SDcuNUM2LjgzNjk2IDI1IDYuMjAxMDcgMjQuNzM2NiA1LjczMjIzIDI0LjI2NzhDNS4yNjMzOSAyMy43OTg5IDUgMjMuMTYzIDUgMjIuNVY3LjVDNSA2LjgzNjk2IDUuMjYzMzkgNi4yMDEwNyA1LjczMjIzIDUuNzMyMjNDNi4yMDEwNyA1LjI2MzM5IDYuODM2OTYgNSA3LjUgNSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTcuNSA1VjEwSDEwVjUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIyLjUgMjQuNTQ1NFYxNy43MjcySDcuNVYyNC41NDU0IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";